const selfSelector = (state) => state.signals

export default selfSelector
